import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '../views/Login/Login.vue';

import Dashboard from '../views/Dashboard/Dashboard.vue';
import ProfileSettings from '../views/Settings/ProfileSettings';
import Users from '../views/Users/Users.vue';
import Services from '../views/Services/Services.vue';
import Feeds from '../views/Feeds/PostLog.vue';
import EventLog from '../views/Feeds/EventsLog.vue';
import ViewUser from "../views/Users/ViewUser.vue";
import Venues from '../views/Venues/Venues.vue';
import Events from '../views/Events/Events.vue';
import Partners from '../views/Partners/Partners.vue';
import ReportedPosts from '../views/Reported/Post/ReportedPost.vue';
import ReportedUsers from '../views/Reported/User/ReportedUsers.vue';
import ReportedMedias from '../views/Reported/Media/ReportedMedias.vue';
import ExternalTickets from '../views/Venues/ExternalTickets.vue';
import FeedsGraph from "../views/Feeds/FeedsGraph.vue";
import NotFoundPage from '../views/Errors/NotFound.vue';
import Forbidden from '../views/Errors/Forbidden.vue';
import Sales from '../views/Sales/Sales.vue';
const Marketing = () => import("../views/Marketing/Marketing");
const AnnouncementDetails = () => import("../views/Marketing/AnnouncementDetails");
const AddAnnouncement = () => import("../views/Marketing/AddAnnouncement");

Vue.use(VueRouter);

const routes = [{
        name: 'Root',
        path: '/',
        component: Login,
        meta: {
            item: null,
            title: 'Login',
        },
    },

    {
        name: 'Login',
        path: '/login',
        component: Login,
        meta: {
            item: null,
            title: 'Login',
        },
    },
    //Setting Pages
    {
        name: 'ProfileSettings',
        path: '/settings/profile',
        component: ProfileSettings,
        meta: {
            item: 'profile',
            title: 'Profile',
        },
    },
    {
        name: 'Dashboard',
        path: '/dashboard',
        component: Dashboard,
        meta: {
            item: 'dashboard',
            title: 'Dashboard',
        },
    },
    {
        name: 'Users',
        path: '/users',
        component: Users,
        meta: {
            item: 'users',
            title: 'Dashboard',
        },
    },
    {
        name: 'Sales',
        path: '/sales',
        component: Sales,
        meta: {
            item: 'sales',
            title: 'Sales',
        },
    },
    {
        name: 'Venues',
        path: '/venues',
        component: Venues,
        meta: {
            item: 'venues',
            title: 'Dashboard',
        },
    },
    {
        name: 'Events',
        path: '/events',
        component: Events,
        meta: {
            item: 'events',
            title: 'Dashboard',
        },
    },
    {
        name: 'Partners',
        path: '/partners',
        component: Partners,
        meta: {
            item: 'partners',
            title: 'Dashboard',
        },
    },
    {
        name: 'FeedPost',
        path: '/feeds',
        component: Feeds,
        meta: {
            item: 'feeds',
            title: 'Feeds',
        },
    },
    {
        name: 'EventsLog',
        path: '/events-log',
        component: EventLog,
        meta: {
            item: 'events-log',
            title: 'events-log',
        },
    },
    {
        name: 'ReportedPosts',
        path: '/reported-posts',
        component: ReportedPosts,
        meta: {
            item: 'reported-posts',
            title: 'reported-posts',
        },
    },
    {
        name: 'ReportedUsers',
        path: '/reported-users',
        component: ReportedUsers,
        meta: {
            item: 'reported-users',
            title: 'reported-users',
        },
    },
    {
        name: 'ReportedMedias',
        path: '/reported-medias',
        component: ReportedMedias,
        meta: {
            item: 'reported-medias',
            title: 'reported-medias',
        },
    },
    {
        name: "FeedsGraph",
        path: "/feeds-graph",
        component: FeedsGraph,
        meta: {
            item: "feeds-graph",
        },
    },
    {
        name: "ViewUser",
        path: "/users/:userId",
        component: ViewUser,
        meta: {
            item: "users",
        },
    },
    {
        name: "Services",
        path: "/services",
        component: Services,
        meta: {
            item: "services",
        },
    },
    {
        name: "ExternalTickets",
        path: "/external-tickets",
        component: ExternalTickets,
        meta: {
            item: "externalTickets",
        },
    },
    {
        name: 'Marketing',
        path: '/marketing',
        component: Marketing,
        meta: {
            item: 'marketing',
            title: 'Marketing',
        },
    },
    {
    name: "AnnouncementDetails",
    path: "/marketing/announcement-details",
    component: AnnouncementDetails,
    meta: {
      item: "marketing",
      title: "Marketing",
    },
  },
  {
    name: "AddAnnouncement",
    path: "/marketing/announcement/form/:type",
    component: AddAnnouncement,
    meta: {
      item: "marketing",
      title: "Marketing",
    },
  },
  {
    name: "EditAnnouncement",
    path: "/marketing/announcement/form/:type/:id",
    component: AddAnnouncement,
    meta: {
      item: "marketing",
      title: "Marketing",
    },
  },
    //403
    {
        name: 'Forbidden',
        path: '/forbidden',
        component: Forbidden,
        meta: {
            item: null,
            title: 'Permission Denied',
        },
    },

    //404
    {
        name: 'NotFound',
        path: '*',
        component: NotFoundPage,
        meta: {
            item: null,
            title: 'Not FOund',
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;